import React, { useEffect } from "react";
import SearchForm from "../../component/searchPage/SearchForm";
import SearchDropdown from "../../component/searchPage/SearchDropdown";
import SearchInput from "../../component/searchPage/SearchInput";
import { downloadBulletinPDF, getSearchCriteria, getSearchResults } from "../../service/SalesNews";
import { PdfLink } from "../../component/searchPage/PdfLink";
import { useTranslation } from "react-i18next";
import { downloadAllSalesNewsResult } from "../../service/SalesNews";
import { usePushToDataLayer } from "../../hooks/usePushToDataLayer";
import { GTM_EVENTS } from "../../utils/constants";

const exportToolbar = (t) => ({
	type: 'bulletins',
	pdf: {
		download_selected: {
			isrequired: true,
			label: t('Download Selected Files (PDF)'),
			warning: t('Please select at least one Sales News'),
			severity: 'warning'
		},
		download_all: {
			isrequired: true,
			label: t('Download All Files (PDF)')
		}
	},
	excel: {
		download_selected: {
			isrequired: true,
			label: t('Export Selected to Excel'),
			warning: t('Please select at least one Sales News'),
			severity: 'warning'
		},
		download_all: {
			isrequired: true,
			label: t('Export All to Excel')
		}
	},
	email: {
		email_selected_pdf: {
			isrequired: true,
			label: t('Email Selected Files (PDF)'),
			warning: t('Please select at least one Sales News'),
			severity: 'warning'
		},
		email_all_pdf: {
			isrequired: true,
			label: t('Email All Files (PDF)')
		}
	}
});

function renderLink(params) {
	const { bulletin_no, link } = params.value;
	return (
		<PdfLink href={`${link}`} tabIndex={params.tabIndex}>
			{bulletin_no}
		</PdfLink>
	);
}


const columns = (t) => [
	{ field: "numberAndLink", headerName: t("Sales News No"), width: 170, renderCell: renderLink, valueFormatter: (value) => `${value.bulletin_no}` },
	{ field: "description", headerName: t("Description"), minWidth: 300, flex: 1 },
	{ field: "bulletin_type", headerName: t("Type"), width: 200 },
	{ field: "promo_start_dt", headerName: t("Effective Date"), width: 140 },
	{ field: "promo_end_dt", headerName: t("Promo End"), width: 140 },
	{ field: "bulletin_dt", headerName: t("Published Date"), width: 170, sort: "desc" },
];

function SalesNews() {
	const { t } = useTranslation();
	const pushToDL = usePushToDataLayer();
	useEffect(() => {
		pushToDL(GTM_EVENTS.PAGE_LOAD, {
			page: {
				name: 'sales_news',
				template: 'sales_news'
			},
		});
	}, [])
	
	return (
		<>
		<SearchForm
			title={t('Sales News')}
			columns={columns(t)}
			criteriaFn={getSearchCriteria}
			searchFn={getSearchResults}
			getAllResult={downloadAllSalesNewsResult}
			exportToolbar={exportToolbar(t)}
			downloadFns={{title:'SalesNews', zip: downloadBulletinPDF}}>
				<div className="search__body--column">
					<SearchDropdown label={t('Model Name')} dataLabel='models' multiple />
					<SearchDropdown label={t('Type')} dataLabel='salesNewsTypes' />
					<SearchDropdown label={t('Published Period')} dataLabel='bulletinDt' />
					<SearchInput label={t('Description')} dataLabel='description' />
				</div>
				<div className="search__body--column">
					<SearchDropdown label={t('Sales News No')} dataLabel='salesNewsNos' />
					<SearchDropdown label={t('Effective Period')} dataLabel='promoStartDt' />
					<SearchDropdown label={t('Promo End')} dataLabel='promoEndDt' />
				</div>
		</SearchForm>
		</>
	);
}

export default SalesNews;
